/**
 * Free accounts can design an invitation and a gallery, but every way of
 * getting a link (publish, gallery share link or custom URL, Live Moments,
 * invitation emails) needs a plan. The server enforces it with
 * 402 { code: 'PAYWALL', action }; this mirrors it so buttons can open the
 * paywall before calling the server. Keep in sync with backend utils/paywall.js.
 */

export const PAYWALL_EVENT = 'handfastly:paywall';

/** @typedef {'publish'|'share'|'moments'|'create'} PaywallAction */

const FREE_PLAN_IDS = new Set(['trial', 'free']);
const STAFF_ROLES = new Set(['admin', 'manager']);

/** True when the account has no paid entitlement (trial/free, or a promo whose 30 days ran out). */
export function isFreeAccount(user) {
  if (!user) return true;
  if (STAFF_ROLES.has(user.role)) return false;
  const sub = user.subscription || {};
  if (FREE_PLAN_IDS.has(sub.plan || 'trial')) return true;
  return Boolean(sub.couponCode && sub.couponTrialEndsAt && new Date(sub.couponTrialEndsAt) < new Date());
}

/** @param {PaywallAction} action */
export function openPaywall(action) {
  window.dispatchEvent(new CustomEvent(PAYWALL_EVENT, { detail: { action } }));
}

/** True for a server 402 PAYWALL answer — the global handler already opened the paywall, so skip the error toast. */
export function isPaywallError(err) {
  return err?.response?.status === 402 && err.response.data?.code === 'PAYWALL';
}
